import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { useEmbed } from '../contexts/EmbedContext'

interface ProtectedRouteProps {
  children: React.ReactNode
  customerOnly?: boolean
}

export default function ProtectedRoute({ children, customerOnly = false }: ProtectedRouteProps) {
  const { isAuthenticated, loading, userType } = useAuth()
  const { loginPath } = useEmbed()

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={customerOnly ? loginPath : '/login'} replace />
  }

  const isCustomer = userType === 'TENANT_CUSTOMER' || userType === 'member'

  // Members must not access staff routes
  if (!customerOnly && isCustomer) {
    return <Navigate to="/customer/dashboard" replace />
  }

  // Staff/admins must not access customer portal routes
  if (customerOnly && userType && !isCustomer) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
